import { Link, LinkProps } from "react-router-dom";
import { preloadRoute } from "@/lib/route-preloader";

interface PreloadLinkProps extends LinkProps {
  /**
   * Disable preloading for this specific link
   */
  disablePreload?: boolean;
}

/**
 * Enhanced Link component that preloads route on hover/focus
 * Improves perceived performance by loading route code before user clicks
 */
export const PreloadLink = ({ 
  to, 
  disablePreload = false,
  onMouseEnter,
  onFocus,
  ...props 
}: PreloadLinkProps) => {
  const handleMouseEnter = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!disablePreload && typeof to === 'string') {
      preloadRoute(to);
    }
    onMouseEnter?.(e);
  };

  const handleFocus = (e: React.FocusEvent<HTMLAnchorElement>) => {
    if (!disablePreload && typeof to === 'string') {
      preloadRoute(to);
    }
    onFocus?.(e);
  };

  return (
    <Link
      to={to}
      onMouseEnter={handleMouseEnter}
      onFocus={handleFocus}
      {...props}
    />
  );
};
